module.exports = __webpack_public_path__ + "static/media/filters.ae3aff5a.svg";